<div class="footerContainer">
  <mat-toolbar color="primary"></mat-toolbar>
</div>
